/* eslint-disable max-len */
// Document processing utilities

import { SUPPORTED_DOCUMENT_FORMATS } from '../types';
import type { UploadResult } from '../types';
import { extractFileTypeFromUrl, generateRandomId } from './commonHelpers';

/**
 * Default document thumbnails based on file type
 */
export const getDocumentThumbnail = (fileType: string): string =>
{
	const iconMap: {[key: string]: string} = {
		pdf     : '/images/icons/pdf_icon.png',
		doc     : '/images/icons/doc_icon.png',
		docx    : '/images/icons/doc_icon.png',
		xls     : '/images/icons/xls_icon.png',
		xlsx    : '/images/icons/xls_icon.png',
		ppt     : '/images/icons/ppt_icon.png',
		pptx    : '/images/icons/ppt_icon.png',
		txt     : '/images/icons/txt_icon.png',
		rtf     : '/images/icons/txt_icon.png',
		// Default icon for unknown types
		default : '/images/icons/document_icon.png'
	};

	return iconMap[fileType] || iconMap.default;
};

/**
 * Processes a document URL to extract metadata
 */
export const processDocumentUrl = (url: string): UploadResult | null =>
{
	// Get file type from URL extension
	const fileType = extractFileTypeFromUrl(url);

	// Make sure we have a valid file type
	if (!fileType || !SUPPORTED_DOCUMENT_FORMATS.includes(fileType))
	{
		return null;
	}

	// Create a filename-friendly title
	const title = `document-${generateRandomId()}`;

	// Get a thumbnail based on the file type
	const thumbnail = getDocumentThumbnail(fileType);

	// Build result object
	const result = {
		url,
		source         : 'embed_link',
		thumbnail,
		fileType,
		title,
		platform       : 'document_url',
		readyForUpload : true
	};

	return result;
};